module.exports = __webpack_public_path__ + "static/media/20210411_150515_091_IMG_0458.cb832be4.jpg";